<template>
  <div class="category-summary" v-if="groupedCategory.active === 1 && activeProducts.length !== 0">
    <div class="category-summary__header-container">
      <h4 class="category-summary__title" v-if="groupedCategory.name !== 'INCENTIVE'">{{ groupedCategory.name }}</h4>
      <h4 class="category-summary__title" v-else>{{ groupedCategory.title }}</h4>
      <p class="product-summary__price" v-if="groupedPrice !== 0">
        {{ groupedPrice | toDisplayPrice }}
      </p>
      <p class="category-summary__title" v-else>inbegrepen</p>
    </div>
    <ul>
      <li v-for="product in activeProducts" :key="product.product_id" class="product-summary">
        <p class="product-summary__name">{{ product.product_name }}</p>
        <p class="product-summary__price" v-if="product.product_price !== 0">
          {{ product.product_price | toDisplayPrice }}
        </p>
        <p class="product-summary__price" v-else-if="product.initialActive">inbegrepen</p>
        <div class="product-summary__price" v-else>gratis</div>
      </li>
    </ul>
  </div>
</template>

<script>
import priceFilters from '../filters/priceFilters'

export default {
  props: {
    groupedCategory: Object
  },
  computed: {
    activeProducts: function () {
      const activeProducts = []
      this.groupedCategory.children.forEach(category => {
        category.products.forEach(product => {
          if (product.active || product.active === 1) {
            activeProducts.push(product)
          }
        })
      })
      return activeProducts
    },
    groupedPrice: function () {
      return this.activeProducts.reduce((total, product) => {
        if (product.active || product.active === 1) {
          total += parseFloat(product.product_price)
        }

        return total
      }, 0)
    }
  },

  filters: {
    toDisplayPrice: priceFilters.toDisplayPrice
  }
}
</script>

<style lang="scss" scoped>
.category-summary {
  border-bottom: solid 1px $color-border;
  padding: 20px 0;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  ul li {
    font-weight: 300;
    font-size: 14px;

    margin: 5px auto;
  }
}

.category-summary__header-container {
  display: flex;
  justify-content: space-between;

  & > * {
    margin: 0;
  }
}

.category-summary__title {
  display: inline-block;
  text-align: left;
}

.category-summary__price {
  display: inline-block;
  text-align: right;
  font-weight: bold;
}

.product-summary {
  display: flex;
  justify-content: space-between;
}

.product-summary__name {
  margin: 0;
}

.product-summary__price {
  margin: 0;
  min-width: max-content;
}
</style>
